export default __webpack_public_path__ + "static/media/coloured-card.e5ca7bd7.jpg";